export default {"src":"/_next/static/media/bobsport.cef0b6cf.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};